import gql from 'graphql-tag';

export const REMOVE_EQUIPMENT_ASSET = gql`
  mutation RemoveEquipmentAsset($input: EquipmentRemoveAssetInput!) {
    equipment {
      result: removeAsset(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
